/**
 * 联网搜索开关（T12）。
 *
 * 只是一个受控按钮：开关状态与持久化由上层负责（`t12.searchEnabled`），本组件只负责
 * 「可见 + 可访问 + 登记元数据」。定位样式由父级传入（与对话页其它部件共用画布坐标换算）。
 */

import { motion } from 'framer-motion';
import type { CSSProperties, ReactElement } from 'react';

import { useMotionPresets } from '../../design/motion';
import { useComponentMeta } from '../../ui';
import { AppIcon } from '../../ui/AppIcon';
import { searchComponentMeta } from './componentMeta';
import styles from './search.module.css';

export interface SearchToggleProps {
  enabled: boolean;
  onToggle: (next: boolean) => void;
  /** 由父级按 390x844 画布坐标换算的绝对定位样式。 */
  style?: CSSProperties;
}

export function SearchToggle({ enabled, onToggle, style }: SearchToggleProps): ReactElement {
  const presets = useMotionPresets();
  const buttonRef = useComponentMeta<HTMLButtonElement>(
    searchComponentMeta('chat.search.toggleButton'),
  );

  return (
    <motion.button
      ref={buttonRef}
      type="button"
      className={styles.toggle}
      style={style}
      data-ui-id="chat.search.toggleButton"
      data-ui-role="button"
      data-enabled={enabled ? 'true' : 'false'}
      aria-pressed={enabled}
      aria-label={enabled ? '关闭联网搜索' : '开启联网搜索'}
      title={enabled ? '联网搜索：已开启' : '联网搜索：已关闭'}
      whileTap={presets.tap.whileTap}
      transition={presets.tap.transition}
      onClick={() => onToggle(!enabled)}
    >
      <AppIcon name="search" size={21} />
    </motion.button>
  );
}
